import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../../../../redux/actions/AppActionFunctions/AppActions';
import DataTableView from './DataTableViewV3';
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('map state to props', { state, ownProps });
    const typeFilter = 'Geofence';
    const childFirstGeofences = state.AppReducer.applicationData.getNodesOfType(typeFilter);
    return {
        isAuthenticated: state.AccessReducer.isAuthenticated,
        cognitoUser: state.AccessReducer.cognitoUser,
        userGroupRoles: state.AppReducer.userGroupRoles,
        userSelectedGroup: state.AppReducer.userSelectedGroup,
        user: state.AppReducer.user,
        contextCustomer: state.AppReducer.contextCustomer,
        viewObjects: [],
        childFirstGeofences,
        redirect: state.AppReducer.redirect,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DataTableView);
